var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 29.333C8.636 29.333 2.667 23.364 2.667 16S8.636 2.667 16 2.667 29.333 8.636 29.333 16 23.364 29.333 16 29.333zm0-2.666c5.891 0 10.667-4.776 10.667-10.667S21.891 5.333 16 5.333 5.333 10.109 5.333 16 10.109 26.667 16 26.667zm0-12c.736 0 1.333.597 1.333 1.333v5.333a1.333 1.333 0 0 1-2.666 0V16c0-.736.597-1.333 1.333-1.333zm0-5.334a1.333 1.333 0 0 1 0 2.666 1.333 1.333 0 0 1 0-2.666z"
  })));
};
export default SvgInfo;